export default [
  { name: 'Question', prop: 'question', type: 'text' },
  { name: 'Help text eg. "minutes"', prop: 'secondary_text', type: 'text' },
  { name: 'Graph name eg. "Writing"', prop: 'graph_name', type: 'text' },
  { name: 'Requires value', prop: 'requires_value', type: 'checkbox' },
  { name: 'Completes checkin', prop: 'completes_checkin', type: 'checkbox' },
  { name: 'Question #', prop: 'number', type: 'number', min: 1 }
]
